import { Row, Col } from "react-bootstrap";
import { Slider, Typography } from "@mui/material";

export default function OverlayOpacity(props) {
  const {
    transparentFocus,
    transparentSettings,
    setTransparentSettings,
    setTransparentFocus,
    opacityValue,
    setOverlayOpacity,
    disableOverlaySteps,
  } = props;
  return (
    <Col className="slide-option">
      <Row>
        <Col>
          <Row
            className={`mb-3 py-1 ${transparentFocus === "overlay-opacity"
              ? "transparent-focus"
              : transparentSettings
                ? "transparent-opacity"
                : ""
              }`}
          >
            <Col className="label-container d-flex align-items-center">
              <Typography
                variant="form-group-label"
                owner="admin"
              >
                Overlay opacity
              </Typography>
            </Col>
            <Col>
              <Slider
                value={opacityValue}
                step={disableOverlaySteps ? 1 : 0.1}
                min={0}
                max={1}
                valueLabelDisplay="auto"
                onChange={(e) => {
                  setOverlayOpacity(e.target.value);
                }}
                onMouseDown={() => {
                  setTransparentSettings(true);
                  setTransparentFocus("overlay-opacity");
                }}
                onChangeCommitted={() => {
                  setTransparentSettings(false);
                  setTransparentFocus("");
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>
  )
}